import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { client } from "../services/api";
//import Status from '../images/status.svg'
import Requests from "./Requests";
import { format } from "date-fns";
import User from '../images/user.png';
import Like from '../images/like.svg';
import Bookmark from '../images/bookmark.svg';
import Trash from '../images/trash.svg';
import HoverEditable from "./HoverEditable";
import Modal from "./Modal";

function ActivityItem({ project }) {
  const [requests, setRequests] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [isDescriptionModalOpen, setDescriptionModalOpen] = useState(false);
  const [isMembersModalOpen, setMembersModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    client.getRequestsByProject(project._id)
      .then((resp) => setRequests(resp.data))
      .catch((err) => console.error(err.message));
    client.getNotificationsByProject(project._id)
      .then((resp) => setNotifications(resp.data))
      .catch((err) => console.error(err.message));
    // eslint-disable-next-line
  }, []);

  const addToFavourite = () => {
    client.logAction('addToFavourite', { projectId: project._id });
  };

  const addToBookmarks = () => {
    client.logAction('addToBookmarks', { projectId: project._id });
  };

  const deleteProjet = () => {
    if(window.confirm(`Do you want to delete project id:${project._id}`)) {
      client.deleteProject(project._id);
    }
  };

  return (
    <div className="activity-item">
      <div style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <h5>{project.name}</h5>
          <span style={{
            color: '#00BA29',
            marginLeft: 20
          }}>ACTIVE</span>
        </div>
        <span><img style={{ width: '17px', filter: 'grayscale(100%)' }} src={User} alt="User" /> {project.user?.email}</span>
      </div>
      <small>{project?.createDate && format(new Date(project.createDate), "yyyy/MM/dd")}</small>
      
      <HoverEditable onEdit={() => setDescriptionModalOpen(true)}>
        <div className="section-bubble">
          {project.description}
        </div>
      </HoverEditable>
      <Modal isOpen={isDescriptionModalOpen} onClose={() => setDescriptionModalOpen(false)} className="large">
        <h6>Project Description</h6>
        <textarea
          placeholder="Description (less than 100 words)"
          className="description"
          style={{ width: "100%" }}
          value={project.description}
          onChange={(e) => null}
        />
        <div className="modal-actions">
          <button className="outline" onClick={() => setDescriptionModalOpen(false)}>Cancel</button>
          <button className="dark" onClick={() => setDescriptionModalOpen(false)}>Done</button>
        </div>
      </Modal>
      {requests?.length > 0 && (
        <div className="section-bubble">
          <h6>Ongoing Requests</h6>
          <Requests requests={requests} min={true} />
        </div>
      )}
      {project.members.length > 0 && (
        <div className="section-bubble">
          <h6>Members</h6>
          {project.members.map((member) => (
            <div key={member._id} style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span><img style={{ width: '17px', filter: 'grayscale(100%)' }} src={User} alt="User" /> {member.email}</span>
              <span>{member.admin ? 'Admin' : 'Contributor'}</span>
              <span>01/01/2025</span>
            </div>
          ))}
          <button className="button-link" onClick={() => setMembersModalOpen(true)}>All members</button>
          <Modal isOpen={isMembersModalOpen} onClose={() => setMembersModalOpen(false)} className="large">
            <h6>All Members</h6>
            <span>Add Member</span>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <input
                type="email"
                //value={newMember} TODO: add member to project._id
                //onChange={(e) => setNewMember(e.target.value)}
                placeholder="Enter email"
              />
              <button className="dark" onClick={() => null}>Add</button>
            </div>
            <span>Members</span>
            {project.members.map((member) => (
              <div key={member._id} style={{ display: 'flex', justifyContent: 'space-between', border: '1px solid #000', borderRadius: '10px', padding: '10px', marginBottom: '6px' }}>
                <span><img style={{ width: '17px', filter: 'grayscale(100%)' }} src={User} alt="User" /> {member.email}</span>
                <span>
                  <select>
                    <option selected={!!member.admin} value="admin">Admin</option>
                    <option selected={!member.admin} value="contributor">Contributor</option>
                  </select>
                </span>
                <span>01/01/2025</span>
                <span><button className="button-link" onClick={(e) => null} //TODO: remove member._id from project._id
                  style={{ color: '#f0941d' }}>Remove user</button></span>
              </div>
            ))}
            <div className="modal-actions">
              <button className="outline" onClick={() => setMembersModalOpen(false)}>Cancel</button>
              <button className="dark" onClick={() => setMembersModalOpen(false)}>Done</button>
            </div>
          </Modal>
        </div>
      )}
      {notifications?.length > 0 && (
        <div className="section-bubble">
          <h6>
            Notifications <span style={{ color: "red" }}>({notifications.length})</span>
          </h6>
          {notifications.map((notification) => (
            <div key={notification._id} className="notification-item">
              <div className="icon red"></div>
              <div className="data">
                <div>{notification.datetime}</div>
                <div>{notification.description}</div>
              </div>
              { /* eslint-disable-next-line */ }
              <a onClick={() => navigate("/")}>More details</a>
            </div>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <img onClick={addToFavourite} style={{ cursor: 'pointer', height: '15px' }} src={Like} alt="favourite" />
          <img onClick={addToBookmarks} style={{ cursor: 'pointer', height: '15px', padding: '0 10px' }} src={Bookmark} alt="bookmark" />
          <img onClick={deleteProjet} style={{ cursor: 'pointer', height: '15px' }} src={Trash} alt="delete" />
        </div>
        { /* eslint-disable-next-line */ }
        <a onClick={() => navigate("/monitoring")}>Go to GIS</a>
      </div>
    </div>
  );
}

export default ActivityItem;
